import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

export const titleCss: CSSObject = {
  lineHeight: "2rem",
  marginBottom: "1.5rem",
};

export const prosemirrorContainerCss: CSSObject = {
  // ProseMirror sets contenteditable="false" in read-only mode, which causes
  // browsers to apply user-select: none via their UA stylesheet. Override this
  // so users can still select and copy text throughout the editor content.
  ".ProseMirror": {
    userSelect: "text",
    WebkitUserSelect: "text",
  },

  '[data-prosemirror-node="cards_section"]': {
    padding: 20,
    background: constants.colors.ui.neutral[25],
    border: `1px solid ${constants.colors.ui.neutral[50]}`,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(278px, 1fr))",
    gap: 18,
    paddingTop: "18px",
    borderRadius: "1rem",
    gridAutoRows: "1fr",

    "div > article": {
      minWidth: 0,
      height: "100%",
    },

    "> div:empty": {
      display: "none",
    },
  },
};
